import { observable, action } from 'mobx'
import { SHOP_PRODUCTS_PATH } from '@constant'
import { hashHistory } from 'react-router'

class Store {
  initialTab = '1'

  @observable tab = this.initialTab

  @action
  changeTab = (value = this.initialTab) => {
    this.tab = value
  }

  /*
        点击服务弹窗提示
     */
  @observable isTipModalShow = false
  @action
  handleOk = () => {
    hashHistory.push(SHOP_PRODUCTS_PATH)
    this.handleCancel()
  }

  @action
  handleCancel = () => {
    this.isTipModalShow = false
  }
}

export default new Store()
